import ShinyText from "@/components/ui/ShinyText";
import { ToofiCard } from "@/components/ui/reader-ai/toofi-card";
import type { ToofiProductIntent } from "@/types/agentic-chat";

const THINKING_LABELS: Partial<Record<ToofiProductIntent, string>> = {
  build_plan: "Shaping your plan",
  daily_plan: "Building today's plan",
  plan_refine: "Refining your plan",
  plan_recovery: "Recovering your plan",
  exam_sprint: "Preparing your exam sprint",
  weak_spot_review: "Checking weak spots",
  deep_review: "Checking weak spots",
  report_followup: "Reviewing follow-up",
  quiz_me: "Building a quiz",
  note_create: "Organizing notes",
  deep_synthesis: "Finalizing output",
  revision_map: "Finalizing output",
};

export function ReaderAiThinkingState({ productIntent }: { productIntent?: ToofiProductIntent | null }) {
  const label = productIntent ? THINKING_LABELS[productIntent] ?? "Thinking" : "Thinking";
  return (
    <div className="mb-2 px-1">
      <ToofiCard variant="meta" className="inline-flex items-center px-3 py-1.5 shadow-[0_12px_30px_rgba(148,163,184,0.14)]">
        <ShinyText
          text={label}
          speed={3.4}
          shineColor="rgba(217,119,6,0.92)"
          className="text-[12px] font-semibold text-slate-500"
        />
      </ToofiCard>
    </div>
  );
}
